module.exports = __webpack_public_path__ + "static/img/1.f57450d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/1.png
// module id = IQF8
// module chunks = 0